import { render } from "./LevelsIndex.vue?vue&type=template&id=9b241a9a&ts=true"
import script from "./LevelsIndex.vue?vue&type=script&lang=ts"
export * from "./LevelsIndex.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__